import auth from './auth.js';
import router from '../versa/router.js';
import db from '../versa/db.js';
import shell from './views/shell.js';
import about from './views/about.js';
import companies from './cruds/companies.js';
import suppliers from './cruds/suppliers.js';
import customers from './cruds/customers.js';
import carriers from './cruds/carriers.js';
import devices from './cruds/devices.js';
import units from './cruds/units.js';
import classes from './cruds/classes.js';
import categories from './cruds/categories.js';
import manufacturers from './cruds/manufacturers.js';
import products from './cruds/products.js';
import warehouses from './cruds/warehouses.js';
import locations from './cruds/locations.js';
import stocks from './cruds/stocks.js';
import transactions from './cruds/transactions.js';
import replenishments from './cruds/replenishments.js';
import inventories from './cruds/inventories.js';
import input_orders from './cruds/input-orders.js';
import output_orders from './cruds/output-orders.js';
import inputs from './cruds/inputs.js';
import lots from './cruds/lots.js';
import outputs from './cruds/outputs.js';
import price_lists from './cruds/price-lists.js';
import payment_terms from './cruds/payment-terms.js';
import cfops from './cruds/cfops.js';
import programs from './cruds/programs.js';
import invoices from './cruds/invoices.js';
import invoice_lots from './cruds/invoice-lots.js';
import groups from './cruds/groups.js';
import users from './cruds/users.js';
import audit_logs from './cruds/audit-logs.js';
import import_center from './views/import-center.js';

router.set('#companies', companies);
router.set('#suppliers', suppliers);
router.set('#customers', customers);
router.set('#carriers', carriers);
router.set('#devices', devices);
router.set('#units', units);
router.set('#classes', classes);
router.set('#categories', categories);
router.set('#manufacturers', manufacturers);
router.set('#products', products);
router.set('#warehouses', warehouses);
router.set('#locations', locations);
router.set('#stocks', stocks);
router.set('#transactions', transactions);
router.set('#replenishments', replenishments);
router.set('#inventories', inventories);
router.set('#input-orders', input_orders);
router.set('#output-orders', output_orders);
router.set('#inputs', inputs);
router.set('#lots', lots);
router.set('#outputs', outputs);
router.set('#price-lists', price_lists);
router.set('#payment-terms', payment_terms);
router.set('#cfops', cfops);
router.set('#programs', programs);
router.set('#invoices', invoices);
router.set('#invoice-lots', invoice_lots);
router.set('#groups', groups);
router.set('#users', users);
router.set('#logs', audit_logs);
router.set('#logout', auth.logout);
router.set('#about', about);
router.set('#import-center', import_center);

const loadShell = function()
{
	db.define([
		{ store: 'endpoints', keys: [ 'id', 'name' ] },
		{ store: 'groups', keys: [ 'id', 'name' ] },
		{ store: 'users', keys: [ 'id', 'username' ] },
		{ store: 'cities', keys: [ 'id', ['state', 'city'], 'state' ] },
		{ store: 'companies', keys: [ 'id', 'name' ] },
		{ store: 'all_companies', keys: [ 'id', 'name' ] },
		{ store: 'warehouses', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'locations', keys: [ ['company_id', 'warehouse_id', 'id'], ['company_id', 'warehouse_id', 'address'] ] },
		{ store: 'units', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'classes', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'categories', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'manufacturers', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'programs', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'products', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'lots', keys: [ ['company_id', 'id'], ['company_id', 'product_id'] ] },
		{ store: 'payment_terms', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'price_lists', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
		{ store: 'suppliers', keys: [ ['company_id', 'id'], ['company_id', 'nick'] ] },
		{ store: 'customers', keys: [ ['company_id', 'id'], ['company_id', 'nick'] ] },
		{ store: 'carriers', keys: [ ['company_id', 'id'], ['company_id', 'nick'] ] },
		{ store: 'devices', keys: [ ['company_id', 'id'], ['company_id', 'name'] ] },
	], 'sial', 2);
	let name = sessionStorage.username.split('.').map(name => name[0].toLocaleUpperCase() + name.slice(1));		// Always first.last
	document.body.innerHTML = shell(`${name[0]} ${name[1] || ''}`);
	document.querySelector('.menu').addEventListener('click', (ev) =>
	{
		location.hash = '';									// Must be reset so the router can detect a change
		location.hash = ev.target.getAttribute('hash');
	});
	if (!sessionStorage.reset)
	{
		db.init();
		sessionStorage.setItem('reset', 'true');
	}
	router.init();
}

if (!sessionStorage.username)
	auth.login(loadShell);
else
	loadShell();

